import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useLanguage } from '../providers/preferenceProvider';
import '../css/secondaryBar.css';
import '../css/markdown.css';
import { getInformationPages, getInformationPageContent } from '../api/information-page-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useSearchParams } from 'react-router-dom';

const Home = () => {
  const { t } = useLanguage();
  const [tabs, setTabs] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [markdownText, setMarkdownText] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [navExpanded, setNavExpanded] = useState(false);

  useEffect(() => {
    setActiveTabIndex(parseInt(searchParams.get('tabIndex')) || 0);
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [searchParams]);

  useEffect(() => {
    getInformationPages()
      .then((response) => {
        const sortedTabs = [...response.data].sort((a, b) => a.orderIndex - b.orderIndex);
        setTabs(sortedTabs);
      })
      .catch((error) => {
        console.error('Error fetching information pages:', error);
      });
  }, []);
    
  useEffect(() => {
    if (tabs.length === 0) return;

    getInformationPageContent(tabs[activeTabIndex].id)
      .then((response) => {
        setMarkdownText(response.data.content);
      })
      .catch((error) => {
        console.error('Error fetching information page content:', error);
      });
  }, [activeTabIndex, tabs]);

  function handleNavClick() {
    if (isMobile) setNavExpanded((prev) => !prev);
  }

  function changeActiveTabIndex(index) {
    if (index >= 0 && index < tabs.length) {
      searchParams.set('tabIndex', index);
      setSearchParams(searchParams);
      setActiveTabIndex(index);
      if (isMobile) setNavExpanded(false);
    }
  }

  return (
    <>
      <main className="main-container">
        <div className="main-box">
          <div className="main-header">{t.info}</div>
          <div className="sidebar-wrapper max-md:mr-2 max-md:ml-2">
            <div
              className={`md:rounded-tl-none md:rounded-br-none max-md:w-auto secondary-nav${isMobile && navExpanded ? ' expanded' : ''}`}
              onClick={handleNavClick}
            >
              {(!isMobile || navExpanded) &&
                tabs.map((tab, index) => (
                  <div
                    key={tab.title}
                    className={`secondary-nav-item ${index === activeTabIndex ? 'active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); changeActiveTabIndex(index); }}
                  >
                    {tab.title}
                    <span className="secondary-nav-arrow"><FontAwesomeIcon icon={faChevronDown} /></span>
                  </div>
                ))}
              {isMobile && !navExpanded && (
                <div className="secondary-nav-item active">
                  {tabs[activeTabIndex]?.title}
                  <span className="secondary-nav-arrow"><FontAwesomeIcon icon={faChevronDown} /></span>
                </div>
              )}
            </div>
            <div className="info-tab-container mb-2">
              <div className="content-item">
                <div className="secondary-nav-header rounded-r-none">{tabs[activeTabIndex]?.title || 'Loading...'}</div>
                <div className="markdown-content-loader">
                  <ReactMarkdown>{markdownText}</ReactMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Home;